<div class="flex items-center gap-1 min-w-0 overflow-hidden">
  @for (crumb of items(); track $index; let last = $last) {
    @if (crumb.clickable) {
      <button class="breadcrumb-item breadcrumb-item--link" (click)="onClick(crumb.action)">{{ crumb.label }}</button>
    } @else {
      <span class="breadcrumb-item" [class.breadcrumb-item--file]="last">{{ crumb.label }}</span>
    }
    @if (!last) {
      <span class="breadcrumb-sep">/</span>
    }
  }
</div>
